import { Component, OnInit } from "@angular/core";
import { LayoutConfigModel } from "src/app/interfaces/home/layout-config";
import { MenuConfigService } from "src/app/services/home/menu-config.service";

import { MenuConfig } from "src/app/config/menu.config";

import * as objectPath from "object-path";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"]
})
export class HomeComponent implements OnInit {
  config: LayoutConfigModel;
  selfLayout: string;
  asideDisplay: boolean;
  asideSecondary: boolean;
  subheaderDisplay: boolean;
  desktopHeaderDisplay: boolean;
  fitTop: boolean;
  fluid: boolean;

  constructor(private menuConfigService: MenuConfigService) {}

  ngOnInit() {
    this.config = JSON.parse(localStorage.getItem("layoutConfig"));
    this.menuConfigService.loadConfigs(new MenuConfig().configs);
    this.loadScript("assets/js/demo1/scripts.bundle2.js");
    // this.selfLayout = this.config.self.layout;
    // this.asideDisplay = this.config.aside.self.display;
    // this.desktopHeaderDisplay = this.config.header.self.fixed.desktop;

    this.selfLayout = objectPath.get(this.config, "self.layout");
    this.asideDisplay = objectPath.get(this.config, "aside.self.display");
    this.subheaderDisplay = objectPath.get(this.config, "subheader.display");
    this.desktopHeaderDisplay = objectPath.get(
      this.config,
      "header.self.fixed.desktop"
    );
    this.fitTop = objectPath.get(this.config, "content.fit-top");
    this.fluid = objectPath.get(this.config, "content.width") === "fluid";
  }

  public loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement("script");
    script.innerHTML = "";
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }
  
}
